import {useState, useCallback} from 'react';
import {useApi} from '~/modules/api';

export const useCreateQuestionSample = ({
  onSuccess,
}: {
  onSuccess: () => void;
}) => {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<Error | null>(null);
  const [label, setLabel] = useState('');
  const [sampleSize, setSampleSize] = useState('');
  const api = useApi();

  const createSample = useCallback(() => {
    setSubmitting(true);
    setError(null);
    api
      .fetch({
        url: '/ai-support/question-samples',
        method: 'POST',
        data: {label, sampleSize},
      })
      .then(response => {
        if (response.data.status === 'success') {
          setLabel('');
          setSampleSize('');
          onSuccess();
        }
      })
      .catch(error => {
        setError(error);
      })
      .finally(() => {
        setSubmitting(false);
      });
  }, [api, label, sampleSize, onSuccess]);

  return {
    label,
    setLabel,
    sampleSize,
    setSampleSize,
    canCreate: !!label && !!sampleSize,
    createSample,
    error,
    submitting,
  };
};
